import { render, staticRenderFns } from "./VFairBreadcrumb.vue?vue&type=template&id=532d0b14&"
import script from "./VFairBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./VFairBreadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports